<div class="control" [ngClass]="ngClass">
  <label class="radio" *ngFor="let option of options; let index = index">
    <input
      *ngIf="!controlled"
      [name]="name"
      type="radio"
      [value]="option.value"
      [(ngModel)]="value"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onChange.emit($event)"
    />

    <span
      (click)="controlled && onChange.emit(option.value)"
      [ngClass]="{ checked: value == option.value && controlled }"
      [translationEditableDirective]="option.label"
      >{{ option.label | translate }}</span
    >
  </label>
</div>
